<template>
  <div>
    <div id="app">
      <div class="wrapper">
        <textarea
          class="regular-input"
          v-model="message"
          @keydown.enter="send"
          placeholder="composer un..."
        >
        </textarea>

        <emoji-picker @emoji="append" :search="search">
          <div
            class="emoji-invoker"
            slot="emoji-invoker"
            slot-scope="{ events: { click: clickEvent } }"
            @click.stop="clickEvent"
          >
            <svg
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
              />
            </svg>
          </div>
          <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
            <div
              class="emoji-picker"
              :style="{ top: display.y + 'px', left: display.x + 'px' }"
            >
              <div class="emoji-picker__search">
                <input type="text" v-model="search" v-focus />
              </div>
              <div>
                <div v-for="(emojiGroup, category) in emojis" :key="category">
                  <h5>{{ category }}</h5>
                  <div class="emojis">
                    <span
                      v-for="(emoji, emojiName) in emojiGroup"
                      :key="emojiName"
                      @click="insert(emoji)"
                      :title="emojiName"
                      >{{ emoji }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </emoji-picker>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br /><br />
    <br />
  </div>
  <!--   <div class="composer">
    <textarea
      v-model="message"
      @keydown.enter="send"
      placeholder="composer un..."
    ></textarea>
  </div> -->
</template>

<script>
import { apiDomain } from "../../config";
import axios from "axios";

import Conversation from "./Conversation";
import EmojiPicker from "vue-emoji-picker";
export default {
  components: {
    EmojiPicker,
    Conversation,
  },
  props: {
    contact: {
      type: Object,
      default: null,
    },

    max: {
      type: Number,
      default: 5,
    },
    action: {
      type: String,
      default: "https://jsonplaceholder.typicode.com/posts/",
    },
  },
  data() {
    return {
      msg: {
        text: "",
        from: this.$store.state.user.id,
        to: "",
        nameContact: this.$store.state.user.nom,
      },

      message: "",
      files: [],
      input: "",
      search: "",
      /* 
      
      ver2
      Z*/
      imageDataRio: "",
      textNull: null,
      imageNull: null,

      text: "",
      from: this.$store.state.user.id,
      to: 79,
      nameContact: this.$store.state.user.nom,

      files: [],
      preview: null,
      image: null,
      preview_list: [],
      image_list: [],
      /* version 2 */
      apiDomain: "https://apil.auto-turki.com",
      list: [],
      drag: false,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },

      /* ver2 */
    };
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  watch: {
    files: {
      deep: true,
      handler() {
        let success = this.files[0].success;
        if (success) {
          this.fetchMessages();
        }
      },
    },
    activeFriend(val) {
      this.fetchMessages();
    },
    "$refs.upload"(val) {
      console.log(val);
    },
  },
  methods: {
    packPhoto: function (event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          vm.image = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
      console.log(input.files[0]);
    },
    previewImageRio: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageDataRio = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },

    /* ver2 */

    /* version 2 */
    Remove(file, index) {
      this.preview_list.splice(index, 1);
      this.image_list.splice(index, 1);

      console.log("testDelete" + index);
    },

    submitMsg11(e) {
      this.isCreatingAnn = true;
      let formData = new FormData();

      formData.append("from", this.from);
      formData.append("to", this.to);
      formData.append("image", this.$refs.image.files[0]);
      formData.append("nameContact", this.nameContact);

      /*  if (this.text == "") {
        formData.append("text", this.textNull);
        formData.append("image", this.$refs.image.files[0]);
      } else if (this.text != "") {
        formData.append("text", this.textNull);
        formData.append("image", this.imageNull);
      } */

      axios
        .post(
          `${apiDomain}/api/sendPrivateMessage2`,

          formData,
          {
            body: JSON.stringify(this.annonce),
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        .then((res) => {
          this.$noty.success("Annonce ajouter avec Succès ! ");
          this.isCreatingAnn = false;
          this.$router.push("/home/client/dashboard");
        })

        .catch((error) => {
          this.isCreatingAnn = false;
          //console.log(error.response.data);
          if (error.response && error.response.status == 422) {
            this.validationErrors = error.response.data.errors;
          }
        });
    },

    deleteImage(file, i) {
      this.files.splice(i, 1);
    },

    addFiles() {
      this.$refs.files.click();
    },

    submitFiles() {
      let formData = new FormData();

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }

      /*
          Make the request to the POST /select-files URL
        */
      axios
        .post("/file-multiple-preview", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function () {
          console.log("SUCCESS!!");
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },

    handleFilesUpload111() {
      let uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }

      this.getImagePreviews111();
    },

    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (/\.(jpe?g|png|PNG|gif)$/i.test(input.files[index].name)) {
        /*  if (input.files) { */
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          this.image_list.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      } else {
        if (
          confirm(
            "Veuillez choisir uniquement un fichier de type image(jpeg,png,jpg)"
          )
        ) {
          console.log("test" + this.image_list.length);
          this.image_list[this.image_list.length].splice(
            [this.image_list.length],
            1
          );
          this.preview_list[this.preview_list.length].splice(
            [this.preview_list.length],
            1
          );
        }
      }
    },

    getImagePreviews(file, i) {
      for (let i = 0; i < this.image_list.length; i++) {
        if (/\.(jpe?g|png|PNG|gif)$/i.test(this.image_list[i].name)) {
          let reader = new FileReader();

          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };

          reader.readAsDataURL(this.image_list[i]);
        } else {
          if (
            confirm(
              "Veuillez choisir uniquement un fichier de type image(jpeg,png,jpg)"
            )
          ) {
            console.log("test" + this.image_list.length);
            this.image_list.splice(i, 1);
          }
        }
      }
    },
    /* ver2 */

    sendMessage() {
      //check if there message

      axios
        .post("/private-messages/" + this.activeFriend, {
          message: this.message,
        })
        .then((response) => {
          this.message = null;
          this.allMessages.push(response.data.message);
          setTimeout(this.scrollToEnd, 100);
        });
    },

    sendMediaMessage({ target }) {
      const formData = new FormData();
      formData.append("file", target.files[0]);

      this.channel.sendMessage(formData);
      target.value = "";
    },
    /* append(emoji) {
      this.input += emoji;
    }, 
    */
    append(emoji) {
      this.message += emoji;
    },
    send(e) {
      e.preventDefault();

      if (this.message == "" && this.image == "") {
        return;
      }
      /* if (this.message.length < 1) {
        return;
        console.log("lng" + this.message.length);
      } */

      this.$emit("send", this.message);
      this.message = null;
      /* 
      this.message = null;
      this.allMessages.push(response.data.message); */
    },

    sendMessage() {
      //check if there message
      if (!this.message) {
        return alert("Please enter message");
      }
      if (!this.activeFriend) {
        return alert("Please select friend");
      }

      axios
        .post("/private-messages/" + this.activeFriend, {
          message: this.message,
        })
        .then((response) => {
          this.message = null;
          this.allMessages.push(response.data.message);
          setTimeout(this.scrollToEnd, 100);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.composer textarea {
  width: 96%;
  margin: 10px;
  resize: none;
  border-radius: 3px;
  border: 1px solid lightgray;
  padding: 6px;

  margin-top: 20px;
}
</style>


<style>
/* Tailwind CSS-styled demo is available here: https://codepen.io/DCzajkowski/pen/Brxvzj */

.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 44rem;
  height: 4rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 44rem;
  left: 2px !important;
  top: 66px !important;
  height: 8rem;
  overflow: scroll;
  padding: 1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  -webkit-box-shadow: 1px 1px 8px #c7dbe6;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}

.style_img_sendMsg {
  margin: 20px;
}
</style>